import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import LocatorMapListItem from "./LocatorMapListItem";

export default function LocatorMapList( props ) {
    return (
        <Box sx={{minHeight:"400px", maxHeight:"800px", overflowX:"auto"}}>
            {props.data.filter(l => l.curLat!=null && l.curLng!=null).length > 0
            ?
            props.data.filter(l => l.curLat!=null && l.curLng!=null)
                .map((Load, idx) => (<LocatorMapListItem 
                                                key={idx} 
                                                childIdx={idx} 
                                                data={Load} 
                                                user={props.user} 
                                                openChildFx={props.openChildFx}
                                                />
                                            ))
            :
            <Box sx={{textAlign:"center"}}>
                <Typography variant="h6">No Records Found</Typography>
            </Box>
            }
        </Box>
    )
}
